import { Routes } from "@angular/router";
import { ProductCardPageComponent } from "./product-card-page.component";
import { authGuard } from "../../../core/guards/auth.guard";

export const productCardPageRoutes: Routes = [
  {
    path: 'records/product-card',
    component: ProductCardPageComponent,
    canActivate: [authGuard]
  },
  {
    path: 'records/product-card/:id',
    component: ProductCardPageComponent,
    canActivate: [authGuard]
  }
]
